import lotteries from '@data/lotteries';
export default (slug) => {
  if (!slug) { return; }
  return lotteries.find((a) => a.slug == slug);
};
